// extracted by mini-css-extract-plugin
export var checkbox = "_9i-0";
export var circle = "_9i-3";
export var horizontalContainer = "_9i-7";
export var sm = "_9i-5";
export var switch0 = "_9i-2";
export var switchDisabled = "_9i-8";
export var switchEnabled = "_9i-1";
export var textSwitchContainer = "_9i-9";
export var textSwitchOption = "_9i-a";
export var textSwitchOptionSelected = "_9i-b";
export var verticalContainer = "_9i-6";
export var xs = "_9i-4";